import { DefaultUserImage } from "../enum/constants";

export const profilePicture = (imageUrl: any, configData: any) => {
  if (imageUrl && imageUrl !== "true" && imageUrl !== undefined && configData) {
    return `${configData?.awsS3StorageBaseUrl}${configData?.awsS3ImagesContainer}/${configData?.userOriginalImagePrefix}${imageUrl}`;
  } else {
    return DefaultUserImage;
  }
};
